var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoolSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4327",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H31.4999V32H0.5V1Z",
    fill: "white",
    stroke: "#000000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.325 20.6563V6.375C11.325 4.85862 10.0913 3.62498 8.57495 3.62498C7.05858 3.62498 5.82495 4.85862 5.82495 6.375",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32495 6.37501C3.32495 3.48019 5.68009 1.125 8.57495 1.125C11.4698 1.125 13.825 3.48019 13.825 6.37501V20.6563",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 20.6563V6.375C25 4.85862 23.7664 3.62498 22.2501 3.62498C20.7338 3.62498 19.5 4.85862 19.5 6.375",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 6.37501C17 3.48019 19.3552 1.125 22.2501 1.125C25.145 1.125 27.5 3.48019 27.5 6.37501V20.6563",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.375 31.1674C30.4315 32.1109 28.9019 32.1109 27.9583 31.1674C27.0148 30.2238 25.4851 30.2238 24.5417 31.1674C23.5982 32.1109 22.0686 32.1109 21.1251 31.1674C20.1815 30.2238 18.6518 30.2238 17.7083 31.1674C16.7649 32.1109 15.2351 32.1109 14.2917 31.1674C13.3482 30.2238 11.8185 30.2238 10.875 31.1674C9.93151 32.1109 8.40181 32.1109 7.45831 31.1674C6.51488 30.2238 4.98512 30.2238 4.04168 31.1674C3.09818 32.1109 1.5685 32.1109 0.625 31.1674",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.375 26.1322C30.4315 27.0757 28.9019 27.0757 27.9583 26.1322C27.0148 25.1886 25.4851 25.1886 24.5417 26.1322C23.5982 27.0757 22.0686 27.0757 21.1251 26.1322C20.1815 25.1886 18.6518 25.1886 17.7083 26.1322C16.7649 27.0757 15.2351 27.0757 14.2917 26.1322C13.3482 25.1886 11.8185 25.1886 10.875 26.1322C9.93151 27.0757 8.40181 27.0757 7.45831 26.1322C6.51488 25.1886 4.98512 25.1886 4.04168 26.1322C3.09818 27.0757 1.5685 27.0757 0.625 26.1322",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.375 21.0979C30.4315 22.0413 28.9019 22.0413 27.9583 21.0979C27.0148 20.1544 25.4851 20.1544 24.5417 21.0979C23.5982 22.0413 22.0686 22.0413 21.1251 21.0979C20.1815 20.1544 18.6518 20.1544 17.7083 21.0979C16.7649 22.0413 15.2351 22.0413 14.2917 21.0979C13.3482 20.1544 11.8185 20.1544 10.875 21.0979C9.93151 22.0413 8.40181 22.0413 7.45831 21.0979C6.51488 20.1544 4.98512 20.1544 4.04168 21.0979C3.09818 22.0413 1.5685 22.0413 0.625 21.0979",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.625 6.37502H11.3333",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.825 6.37502H24.9916",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4999 6.37502H31.3749",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0043 11.875H13.8375V9.375H25.0043V11.875Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5957 17.375H13.825V14.875H24.9916V17.375H22.2207",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolSide);
export default __webpack_public_path__ + "static/media/pool_side.428039d3ebe0c1c2ac11a33466ef16ea.svg";
export { ForwardRef as ReactComponent };